import script from "./BuddyListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuddyListItem.vue?vue&type=script&lang=ts&setup=true"

import "./BuddyListItem.vue?vue&type=style&index=0&id=72731f5c&lang=scss"

const __exports__ = script;

export default __exports__